/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ExpertSubscriptions.css";
import community_icon from "../../../images/Oscar.svg";
import { fetchCommunityDataWithPagination } from "../../../Services/Community/CommunityAPI/communityApi";
import PaginationComponent from "../../Pagination/pagination";
import { capitalizeWords } from "../../../Utils/LetterCase";
import Modal from "react-bootstrap/Modal";
import {
  realtorSubscriptionApi,
  realtorFetchSubscriptionApi,
  realtorCancelSubscriptionApi,
} from "../../../Services/Realtor/RealtorApi/RealtorApi";
import { fetchProductList } from "../../../Services/Subscription/subscriptionApi";
import { toast } from "react-toastify";
import Chip from "@mui/material/Chip";
import { Box } from "@mui/material";
import { fetchProfileData } from "../../../Services/Profile/ProfileApi";
import PurchaseSubscriptionModal from "./PurchaseSubscriptionModal";
import UploadBannerModal from "../ExpertSubscriptions/UploadBannerModal";
import ViewImageModal from "./ViewImageModal";
import { useNavigate } from "react-router-dom";
import { encryptId } from "../../../Utils/Crypto";
import { ThreeDot } from "react-loading-indicators";

const ExpertSubscriptions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedSub, setSelectedSub] = useState(null);
  const [price, setPrice] = useState(null);
  const [subType, setSubType] = useState("");
  const [id, setId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [productId, setProductId] = useState("");
  const allCommunity = useSelector(
    (state) => state.fetchCommunityDataWithPagination.data
  );
  const { data, loading, error } = useSelector(
    (state) => state.realtorFetchSubscription
  );
  const { data: products } = useSelector((state) => state.fetchProductList); // Get products from Redux state
  const { data: profileData } = useSelector((state) => state.fetchProfileData);
  const { data: productList } = useSelector((state) => state.fetchProductList);
  const [showSimpleModal, setShowSimpleModal] = useState(false);

  useEffect(() => {
    dispatch(fetchProductList());
  }, [dispatch]);

  useEffect(() => {
    if (productList?.data?.length > 0) {
      const product = productList.data.find(
        (item) => item.metadata.Type.role === userType?.toLowerCase()
      );
      setProductId(product ? product.id : null);
    }
  }, [productList, userType]);

  useEffect(() => {
    dispatch(fetchProductList());
  }, [dispatch]);

  useEffect(() => {
    if (products?.data?.length > 0) {
      const product = products.data.find(
        (item) => item.metadata.Type.role === userType?.toLowerCase()
      );
      setPrice(product?.default_price?.unit_amount);
      setSubType(product?.name);
    }
  }, [products, userType]);

  useEffect(() => {
    dispatch(realtorFetchSubscriptionApi(userId));
  }, [dispatch, userId]);

  useEffect(() => {
    dispatch(
      fetchCommunityDataWithPagination({
        page: page,
        page_size: pageSize,
        search,
      })
    );
  }, [dispatch, page, pageSize, search]);

  useEffect(() => {
    if (allCommunity) setCount(allCommunity?.data?.count);
  }, [allCommunity]);

  const handleCancelSubscription = () => {
    if (selectedSub) {
      console.log("selectedSub", selectedSub);
      const payload = {
        user_id: userId,
        ...(profileData?.data?.is_super_subscribed
          ? { record_id: selectedSub.id }
          : {
              subscription_id: selectedSub.stripe_subscription_id,
              city_id: selectedSub.city_id,
            }),
      };

      dispatch(realtorCancelSubscriptionApi(payload)).then((res) => {
        if (res?.payload?.status === 200) toast.success(res?.payload?.message);
        else toast.error(res?.payload?.message);
        dispatch(realtorFetchSubscriptionApi(userId));
      });
      setShowModal(false);
    }
  };

  const handleOpenModal = (sub) => {
    setSelectedSub(sub);
    setShowModal(true);
  };

  const handleSubmit = async (id) => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      const res = await dispatch(
        realtorSubscriptionApi({
          user_id: userId,
          product_id: productId,
          community_id: id,
        })
      );
      if (res) {
        if (res?.payload?.status === 200) {
          toast.success(res?.payload?.message);
          dispatch(
            fetchCommunityDataWithPagination({
              page,
              page_size: pageSize,
              search,
            })
          );
          dispatch(realtorFetchSubscriptionApi(userId));
          dispatch(fetchProfileData(userId));
        } else if (res?.payload?.status === 400) {
          toast.error(res?.payload?.message);
        }
      }
    } catch (error) {
      console.log("Error:", error);
      toast.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseSimpleModal = () => setShowSimpleModal(false);

  if (loading)
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "75vh",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <ThreeDot color="#e55426" size="small" text="" textColor="" />
        </Box>
      </div>
    );

  return (
    <div>
      <div className="community-section">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-start flex-column">
            <div className="community-heading">
              Real Estate Expert Subscriptions
            </div>
            <div className="expert-title">
              Secure the exclusive right to establish yourself as the
              community's foremost real estate expert.
            </div>
          </div>
          <div className="community-name-table">
            <div className="community-tabs-section d-none"></div>
            <div className="training-ai-blk">
              <div className="tab-content mt-3">
                <div className="contact-content  mt-4 training-ai-block">
                  <div className="contact-us-block-form text-start">
                    <div className="table-inner">
                      <table className="table table-borderless">
                        <thead className="exp-sub-heading">
                          <tr>
                            <th scope="col">Community Name</th>
                            <th scope="col">City</th>
                            <th scope="col">State</th>
                            <th scope="col">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!error ? (
                            data?.data?.map((sub, index) => (
                              <tr key={sub?.id}>
                                <td>{capitalizeWords(sub?.community_name)}</td>
                                <td>{sub?.city}</td>
                                <td>{sub?.state}</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <UploadBannerModal id={sub?.id} />
                                    <button
                                      className="bttn-upload rounded-pill"
                                      onClick={() =>
                                        // handleOpenSimpleModal(
                                        //     sub?.ads_banner_image
                                        // )
                                        navigate(
                                          `/realtor/tab/${encryptId(
                                            sub?.community_id
                                          )}`
                                        )
                                      }
                                    >
                                      View
                                    </button>
                                    {sub?.payment_status !== "30days_trial" && (
                                      <button
                                        className="orange-filled-btn claimbtn cancel-realtors"
                                        onClick={() => handleOpenModal(sub)}
                                        disabled={
                                          sub?.payment_status === "30days_trial"
                                        }
                                      >
                                        Cancel
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              {profileData?.data?.is_trial_activated ? (
                                <td>No active subscription</td>
                              ) : (
                                <td colSpan="8">
                                  🏡 💼 Your path to growth begins now! Claim a
                                  community and enjoy a 30-day free trial on us!
                                </td>
                              )}
                            </tr>
                          )}
                        </tbody>
                      </table>

                      {/* <PaginationComponent
                    count={1}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    page={page}
                    setPage={setPage}
                  /> */}
                      <div>
                        <Modal
                          show={showModal}
                          onHide={() => setShowModal(false)}
                          size="sm"
                          centered
                        >
                          <Modal.Header className="d-flex justify-content-center">
                            <Modal.Title className="fw-bold">
                              Cancel Subscription
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="text-center">
                              <p className="text-muted">
                                Are you sure you want to cancel your
                                subscription for{" "}
                                <b>{selectedSub?.community_name}</b>?
                              </p>
                            </div>
                          </Modal.Body>
                          <Modal.Footer className="d-flex justify-content-between">
                            <button
                              className="bttn-upload"
                              onClick={() => setShowModal(false)}
                            >
                              No, Keep It
                            </button>
                            <button
                              className="bttn-close"
                              onClick={handleCancelSubscription}
                            >
                              Cancel
                            </button>
                          </Modal.Footer>
                        </Modal>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="all-commmunities-table">
          <div className="inner-wrap-all">
            <div className="title-search-block d-flex justify-content-between flex-column">
              <div className="d-flex justify-content-between">
                <div className="community-heading">Find a Community</div>
                <div className="">
                  {subType && <Chip color="primary" label={subType} />}{" "}
                  {price && (
                    <Chip color="success" label={price ? `$${price}` : "N/A"} />
                  )}
                </div>
              </div>
              <div className="community-searchbar-main">
                <div className="inner-searchbar mt-3">
                  <div className="input-searchbar loader-block">
                    <input
                      type="search"
                      // className="inputsearch"
                      value={search}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSearch(value);
                      }}
                      // onChange={handleSearchChange}
                      placeholder="Search by Community Name"
                      // autoComplete="off"
                    />
                    <div className="owl_logo_searchbar">
                      <a href="#">
                        <img
                          src={community_icon}
                          alt="owl_logo"
                          width="20"
                          height="20"
                        ></img>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="community-name-table communityblk">
              <div className="table-inner">
                <table className="table table-borderless">
                  <thead className="exp-sub-heading">
                    <tr>
                      <th scope="col">Community Name</th>
                      <th scope="col">City</th>
                      <th scope="col">State</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allCommunity?.data?.data?.map((community) => (
                      <tr key={community?.id}>
                        <td>{capitalizeWords(community?.community_name)}</td>
                        <td>{community?.location?.city} </td>
                        <td>{community?.location?.state}</td>
                        <td>
                          <button
                            className="orange-filled-btn claimbtn cancel-realtors"
                            onClick={() => {
                              if (
                                profileData?.data?.is_super_subscribed ||
                                !profileData?.data?.is_trial_activated
                              ) {
                                handleSubmit(community?.id);
                              } else {
                                setShowSubscriptionModal(true);
                                setId(community?.id);
                              }
                            }}
                            disabled={
                              (isSubmitting ||
                                community?.is_relator_subscribed) &&
                              !(
                                community?.realtor_id === userId &&
                                community?.realtor_plan === "30days_trial" &&
                                community?.is_relator_subscribed
                              )
                            }
                          >
                            {!community?.is_relator_subscribed ||
                            (community?.realtor_id === userId &&
                              community?.realtor_plan === "30days_trial" &&
                              community?.is_relator_subscribed)
                              ? "Claim"
                              : "Not Available"}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <PaginationComponent
                  count={count}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  page={page}
                  setPage={setPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <PurchaseSubscriptionModal
        show={showSubscriptionModal}
        id={id}
        onHide={() => {
          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }, 200);
          setShowSubscriptionModal(false);
        }}
        fetchSubscription={() => dispatch(realtorFetchSubscriptionApi(userId))}
      />
      <ViewImageModal
        showModal={showSimpleModal}
        handleClose={handleCloseSimpleModal}
      />
    </div>
  );
};

export default ExpertSubscriptions;
